export const DISTANCE_FILTER = {
  ADDRESS: "ADDRESS",
  HCF: "HCF",
};

export const EMPLOYMENT_STATUS = {
  STATUS_W2: "W2",
  STATUS_1099: "1099",
};

export const SHIFT_PREFERENCE = {
  DISTANCE: 150,
  PAY_HOUR: 0,
  PAY_SHIFT: 0,
  BASE_RATE: 17,
};
